<div class="content"></div>
<div class="app-login-container">
	<main class="main d-flex align-items-center">
		<div class="container">
			<div class="row">
				<div class="mx-auto">
					<div class="card-group">
						<div class="card p-4 app-login-container__form">
							<div class="card-header bg-transparent app-login-container__form-header" *ngIf="!isInsideIframe">
								<img src="assets/img/brand/ClassValuation-logo-XS-SM.png" />
							</div>
							<div class="card-body">
								<div class=" mb-3 app-login-container__card-content">
									<div class="fa-3x app-login-container__spinner">
										<i class="fas fa-spinner fa-spin"></i>
									</div>
									<span class="app-login-container__info-text">
										Loading information please wait
									</span>
								</div>
							</div>
						</div>
					</div>

					<br />
					<div class="text-muted app-login-container__footer" *ngIf="!isInsideIframe">
						&copy; {{ today | date: 'yyyy' }} Class Valuation LLC
					</div>
				</div>
			</div>
		</div>
	</main>
</div>
